import { render, staticRenderFns } from "./DomainName.vue?vue&type=template&id=33a57b06&"
import script from "./DomainName.vue?vue&type=script&lang=js&"
export * from "./DomainName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports